import instance from 'api';
import { IAvailableColumnModel, IAvailableGroupColumnModel } from 'interfaces';
import { IDynamicTableParams } from 'components/DynamicTable';
import { IYard } from './interfaces';

export const getYardList = (data: IDynamicTableParams) => {
  return instance()
    .post('/realEstateYard/list', data)
    .then((response) => response.data);
};

export const getYardAvailableColumns = () => {
  return instance()
    .post<IAvailableColumnModel[]>('/realEstateYard/availableColumns', {})
    .then((response) => response.data);
};

export const getYardAvailableGroupColumns = () => {
  return instance()
    .post<IAvailableGroupColumnModel[]>('/realEstateYard/availableGroupColumns')
    .then((response) => response.data);
};

export const loadYard = (id: number) => {
  return instance()
    .get<IYard>(`/realEstateYard/load/${id}`)
    .then((response) => response.data);
};

export const saveYard = (data: { name: string }) => {
  return instance()
    .post('/realEstateYard/save', data)
    .then((response) => response.data);
};

export const updateYard = (id: number, data: { name: string }) => {
  return instance()
    .post(`/realEstateYard/${id}/update`, data)
    .then((response) => response.data);
};

export const archiveYard = (realEstateYardId: number) => {
  return instance()
    .post('/realEstateYard/archive', { realEstateYardId })
    .then((response) => response.data);
};

export const recoverYard = (realEstateYardId: number) => {
  return instance()
    .post('/realEstateYard/recover', { realEstateYardId })
    .then((response) => response.data);
};
